import {
  modals,
  permissionGroups, customers
} from "../../../ducks";
import React, {useState} from "react";
import {Field, Formik} from "formik";
import ModalComponent from "../../ModalComponent";
import {Button, Form, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import ValidationErrors from "../../forms/ValidationErrors";
import './styles/PermissionGroups.scss';
import Select from "react-select";
import levels from "../../../../../config/admin_levels.json";
import duckify, {filterDuck, singleDuck} from "../../../utils/duckify";
import {PermissionChecklist} from "./PermissionChecklist";
import {allowedSchoolDisplay} from "./AdminListPage";

const typeOptions = levels.map((level, i) => { return i !== 4 ? {label: levels[i], value: i} : undefined }).filter(x => !!x)

const RowWithLabel = ({label, children}) => (
  <Row className='mb-3'>
    <label className="form-label col-form-label col-8 text-end">{label}</label>
    <div className="controls col-16">
      {children}
    </div>
  </Row>
);

const inputCss = 'base-setup-field-input smaller-text-field';

const SchoolSection = ({values, handleChange, setValues, schoolList, fieldsToShow}) => {
  const allSchoolsSelected = (values) => schoolList.every(school => values.allowed_schools.includes(school.id));

  const clickSelectAllSchools = (values, setValues) => {
    if (allSchoolsSelected(values)) {
      values.allowed_schools = [];
      values.schools_restricted = true;
    } else {
      values.allowed_schools = schoolList.map(school => school.id);
      values.schools_restricted = false;
    }
    setValues(values);
  }

  const clickSchool = (values, setValues, schoolId) => {
    if (values.allowed_schools.includes(schoolId)) {
      values.allowed_schools = values.allowed_schools.filter(id => id !== schoolId);
      values.schools_restricted = true;
    } else {
      values.allowed_schools.push(schoolId);
      values.schools_restricted = !allSchoolsSelected(values);
    }
    setValues(values);
  }

  return (<>
    {fieldsToShow.includes('allowed_schools') && (<RowWithLabel label='Schools'>
      <Select
        className='admin-school-select'
        closeOnSelect={false}
        clearable={false}
        searchable={false}
        onSelectResetsInput={false}
        onChange={(option)=> option && (option.value === 'schools_restricted' ? clickSelectAllSchools(values, setValues) : clickSchool(values, setValues, option.value))}
        value={{value: 'default'}}
        name='selected_school_ids[]'
        valueRenderer={(option) => allowedSchoolDisplay(values, schoolList)}
        optionRenderer={(option) => (
          <div className={option.value === 'schools_restricted' ? 'permission-group-select-all' : ''}>
            <input
              id={option.value}
              name={option.value}
              key={option.value}
              type='checkbox'
              className='form-check-input'
              checked={option.value === 'schools_restricted' ? !values.schools_restricted : values.allowed_schools.includes(option.value)}
              onChange={() => {}}
            />
            <label className='form-check-label checkbox-school-label'>{option.label}</label>
          </div>
        )}
        options={[{label: 'All Schools', value: 'schools_restricted'}, ...schoolList.map(school => ({label: school.name, value: school.id}))]}
      />
    </RowWithLabel>)}
  </>);
}

const EditAdminModal = ({
                          flags,
                          onClose,
                          onSave,
                          onUnexpectedError,
                          admin = {},
                          groups,
                          showPassword,
                          currentCustomer,
                          subsites,
                          initialValues,
  title
                        }) => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const setGroup = (groupId, values, setValues) => {
    values['permission_group_id'] = groupId || null;
    const entity = groupId ? groups.find(group => group.id === groupId) : admin;
    if (entity) {
      flags.forEach(flag => values[flag.canonical_name] = entity[flag.canonical_name]);
    }
    setValues(values);
  }

  const fieldsToShow = Object.keys(initialValues);

  return <Formik
    initialValues={initialValues}
    onSubmit={
      values => {
        setLoading(true);
        onSave(values)
          .then(onClose)
          .catch(response => {
            setLoading(false);
            if (response.admin && response.admin.errors) {
              setErrors(response.admin.errors);
            } else if (response.errors) {
              setErrors(response.errors);
            } else {
              onClose();
              onUnexpectedError();
            }
          });
      }
    }>
    {
      ({
         values,
         handleChange,
         handleSubmit,
         setValues,
         setFieldValue
       }) => <ModalComponent
        className="edit-permission-modal"
        title={title}
        buttons={[
          <Button type="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        ]}>
        <ValidationErrors errors={errors}/>

        {fieldsToShow.includes('email') && (<RowWithLabel label='Email'>
          <input className={inputCss} type="text" name="email" defaultValue={values.email} onChange={handleChange}/>
        </RowWithLabel>)}

        {fieldsToShow.includes('first_name') && (<RowWithLabel label='First Name'>
          <input className={inputCss} type="text" name="first_name" defaultValue={values.first_name} onChange={handleChange}/>
        </RowWithLabel>)}

        {fieldsToShow.includes('last_name') && (<RowWithLabel label='Last Name'>
          <input className={inputCss} type="text" name="last_name" defaultValue={values.last_name} onChange={handleChange}/>
        </RowWithLabel>)}

        {fieldsToShow.includes('acl') && (<RowWithLabel label='Type'>
          <Select
            className='admin-acl-selector'
            name="acl"
            value={values.acl}
            clearable={false}
            onChange={selected => setFieldValue('acl', selected && selected.value)}
            options={typeOptions}
          />
        </RowWithLabel>)}

        {showPassword && <>
          <RowWithLabel label='Password'>
            <input className={inputCss} type="password" name="password" defaultValue='' onChange={handleChange}/>
          </RowWithLabel>
          <RowWithLabel label='Password Confirm'>
            <input className={inputCss} type="password" name="password_confirm" defaultValue='' onChange={handleChange}/>
          </RowWithLabel>
        </>}

        {subsites.length > 0 && <SchoolSection values={values} handleChange={handleChange} setValues={setValues} schoolList={[currentCustomer].concat(subsites)} fieldsToShow={fieldsToShow} />}
        {fieldsToShow.includes('permission_group_id') && (<RowWithLabel label='Permission Group'>
          <Select
            className='admin-permission-group-selector'
            name="permission_group_id"
            value={values.permission_group_id || ''}
            onChange={selected => setGroup(selected && selected.value, values, setValues)}
            options={[{label: 'Custom Permissions', value: ''}].concat(groups.map(group => ({label: group.name, value: group.id})))}
          />
        </RowWithLabel>)}

        {fieldsToShow.includes('permission_group_id') && (<PermissionChecklist
          flags={flags}
          values={values}
          setValues={setValues}
          handleChange={handleChange}
          disabled={!!values.permission_group_id}
        />)}
      </ModalComponent>
    }
  </Formik>;
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(modals.actions.hide()),
  onUnexpectedError: () => dispatch(modals.actions.show('UnexpectedError'))
});

const mapDucksToProps = () => ({
  groups: filterDuck(permissionGroups, {}),
  currentCustomer: singleDuck(customers, 'current'),
  subsites: filterDuck(customers, {list_subsites: true})
});

export default duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(EditAdminModal);
